module.exports = __webpack_public_path__ + "img/lobby_hosting_bug_report.372dffad.png";